import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from '../Skeleton';
export default function TableSkeletonsRender({ columnKey }) {
    if (columnKey === 'actions') {
        return _jsx(Skeleton, { type: "circle", height: "32px", margin: "0 auto" });
    }
    return _jsx(Skeleton, { type: "rectangle", height: "20px", width: "110px" });
}
//# sourceMappingURL=TableSkeletonsRender.js.map